import { InjectionToken } from "@angular/core";
import { FeatureToggleConfig, FeatureOf } from "../interfaces/feature-toggle-config.interface";

export const FEATURES: InjectionToken<FeatureOf<FeatureToggleConfig>> = new InjectionToken<FeatureOf<FeatureToggleConfig>>('FEATURES')
